import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { MdHistory } from "react-icons/md";
import DialPadButton from "./DialPadButton";
import { useDispatch, useSelector } from "react-redux";
import { SessionState } from "sip.js";
import OngoingScreen from "./OngoingScreen";
import { closeModal, closeSubModal, setSubModal } from "../../features/modal/ModalSlice";

import ConnectingScreen from "./ConnectingScreen";
import { getObjectCount } from "../../utils/sipUtilsFunc";

const DraggablePad = () => {
  const { sessionState, sessions } = useSelector((state) => state.SIPCalls);
  const modal = useSelector((state) => state?.modal?.modal);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(sessionState);
  }, [sessionState]);

  const toggleActivitie = () => {
    if (modal?.subModal?.type === "ACTIVITY") dispatch(closeSubModal());
    else dispatch(setSubModal({ type: "ACTIVITY" }));
  };

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Box
      sx={{
        width: 400,
        // backgroundColor: "#fff",
        // borderRadius: "16px",
        // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        // overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          p: 2.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 600,
            fontSize: "1.125rem",
          }}
        >
          Call
        </Typography>
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            color: "white",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            },
          }}
        >
          <IoClose size={20} />
        </IconButton>
      </Box>


    <Box className="d-flex flex-column justify-content-around"
      sx={{
          minHeight: "calc(100vh - 200px)",
      }}
    >
      
      {/* Activities Button */}
      <Box sx={{ p: 2, pb: 0 }}>
        <Box
          onClick={toggleActivitie}
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: "8px",
            border: "1px solid",
            borderColor: modal?.subModal?.type === "ACTIVITY" ? "#667eea" : "#E5E7EB",
            backgroundColor: modal?.subModal?.type === "ACTIVITY" ? "#F0F4FF" : "transparent",
            color: modal?.subModal?.type === "ACTIVITY" ? "#667eea" : "#6B7280",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": {
              borderColor: "#667eea",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          <MdHistory size={18} />
          <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
            Activities
          </Typography>
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        {sessionState === SessionState.Established ? (
          <OngoingScreen />
        ) : sessions && getObjectCount(sessions) > 0 ? (
          <ConnectingScreen />
        ) : (
          <DialPadButton />
        )}
      </Box>

    </Box>

    </Box>
  );
};

export default DraggablePad;
